import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useLanguage } from "@/context/LanguageContext";
import { ReferralTree } from "@/components/ReferralTree";

export default function Network() {
  const { t } = useLanguage();
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/referral/my-referrals").then((r) => setData(r.data)).catch(() => {}); }, []);
  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-display text-2xl sm:text-3xl font-extrabold text-[#0B223D]">My Referral Network</h1>
        <p className="text-sm text-slate-500 mt-1">{t("net_subtitle")}</p>
      </div>
      <ReferralTree data={data} emptyText={t("net_empty")} />
    </div>
  );
}
